export const USER_ROLE = {
  USER: 'USER',
  INFLUENCER: 'INFLUENCER',
  PARTNER: 'PARTNER',
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
};

export const SEX = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
};

export const STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export const SORTING = {
  ASC: 'ASC',
  DESC: 'DESC',
};

export const DIRECTION = {
  ASC: 'ASC',
  DESC: 'DESC',
};

export const OPERATOR = {
  GTE: 'GTE',
  LTE: 'LTE',
};

export const SUBSCRIPTION_TYPE = {
  MONTHLY: 'MONTHLY',
  CREDIT: 'CREDIT',
  FIX: 'FIX',
};

export const BOOK_TYPE = {
  EBOOK: 'EBOOK',
  FULL: 'FULL',
  SHORT: 'SHORT',
  PODCAST: 'PODCAST',
  MEDITATION: 'MEDITATION',
  STANDUP: 'STANDUP',
};

export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  CANCELED: 'CANCELED',
};

export const CREDIT_SUBSCRIPTION_ACCOUNTING_MODE = Object.freeze({
  FIX_PRICE: 'FIX_PRICE',
  FIX_PRICE_AFTER_CONSUMED_PERCENT: 'FIX_PRICE_AFTER_CONSUMED_PERCENT',
  INFINITE_CONSUMPTION: 'INFINITE_CONSUMPTION',
  PERCENT: 'PERCENT',
})

export const RIGHTOWNER_TYPE = {
  AUDIO: 'AUDIO',
  TRANSLATION: 'TRANSLATION',
};

export const REGEX = {
  PASSWORD_REGEX: /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/i,
  EMAIL_REGEX: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
};

export const SUBSCRIPTION_DURATION = {
  ONE_MONTH: 'ONE_MONTH',
  SIX_MONTHS: 'SIX_MONTHS',
  TWELVE_MONTHS: 'TWELVE_MONTHS',
  TWENTY_MONTHS: 'TWENTY_MONTHS',
  INFINITIVE: 'INFINITIVE',
};

export const PURCHASED_GIFT_STATUS = {
  ACTIVE: 'ACTIVE',
  INITED: 'INITED',
  FALIED: 'FALIED',
  USED: 'USED',
  DELETED: 'DELETED',
};

export const USER_COUPON_TYPE = {
  NORMAL: 'NORMAL',
  CREATED_BY_LINK: 'CREATED_BY_LINK',
};

export const AFFILATE_BOOK_PURCHASE_TYPE = {
  ROYALTIES_INCLUDED: 'ROYALTIES_INCLUDED',
  ROYALTY_FREE: 'ROYALTY_FREE',
  ROYALTIES_INCLUDED_ON_WAIT: 'ROYALTIES_INCLUDED_ON_WAIT',
};

/**
 * @readonly
 * @enum {string}
 */
export const ROYALTY_ACCOUNTING_MODE = Object.freeze({
  AGGREGATED: 'AGGREGATED',
  BOOK_ACTIVATION_ORDER: 'BOOK_ACTIVATION_ORDER',
  PER_BOOK: 'PER_BOOK',
})
